"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _admin = _interopRequireDefault(require("./admin"));
var _editor = _interopRequireDefault(require("./editor"));
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Dashboard',
  components: {
    adminDashboard: _admin.default,
    editorDashboard: _editor.default
  },
  data() {
    return {
      me: null,
      currentRole: 'editorDashboard'
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(['roles'])
  },
  created() {
    this.getMe();
    if (this.roles.includes('root') || this.roles.includes('otr-digital-producer') || this.roles.includes(Constants.USER_ROLE_ADMIN)) {
      this.currentRole = 'adminDashboard';
    }
  },
  methods: {
    getMe() {
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _user.getInfo)(token).then(response => {
        this.me = response.data;
      }).catch(err => {
        (0, _log.showDebugLog)('page-profile-err', err);
      });
    }
  }
};